import * as http from "@/utils/request";
import {jsonToFormData} from "@/utils";


// 分页查询角色列表
export  const roleList =({name,page,size})=>{
    return http.get('/role/findPage',{name,page,size})
  }

//新增角色
export function insert(name,description){
    return http.postForm("/role/insert",name,description);
}

//编辑角色
export function update(name,description,id){
    return http.postForm("/role/update",name,description,id);
}

//删除角色
export function deleteRole(id){
    return http.deleteRequest('/role/delete',{id:id})
}

//获取所有菜单
export function loadMenuAll(){
    return http.get('/role/loadMenuAll',)
}

//用户选择角色权限
export function findRoleMenu(roleId) {
    return http.get("/role/findRoleMenu",{roleId})
}

//新增权限 
export function insertRelation(page,params) {
    return http.postJSON("/role/insertRelation?"+jsonToFormData(page),params)
}

  //查询账号权限  GET /role/getMenuByListID
export function getMenuByListID(str) {
    return http.get("/role/getMenuByListID",{str})
}

// 登录 POST /userSystem/open/login
export function login(params){
  return http.postJSON("/userSystem/open/login",params);
}

//修改密码
export function updatePassword(oldPassword,newPassword){
    return http.postFormData("/userSystem/updatePassword",{oldPassword,newPassword});
  }


// WEBPACK FOOTER //
// ./src/services/role.js